import { Helmet } from 'react-helmet'
import scrollSmoothTo from '../../components/Functionals/Smooth'
import MenuShare from './MenuShare'
import Disclaimer from './Disclaimer'
import menuLink from '../../LunchMenu.pdf'
import menuImage from '../../assets/images/menuLunch.png'
import dishImage from '../../assets/images/lunchImage.jpg'
import dishImageMob from '../../assets/images/lunchImageMob.jpg'

export default function DailyMenu(){
  return (
    <div className="pageStyles daily-menu">
      <Helmet>
        <title>Enjoy Lunch at Villaggio Grille</title>
        <meta name="description" content="Villaggio is open for lunch seven days a week. With so many delicious entrees, you'll be begging people to join you just for an excuse to order more!" />
      </Helmet>

      <div id="menupage" className="nodrops">
        <div id="page-title" className="pt-bkg-image image-menus">
          <div className="overlay">
            <div className="title-container less">
              <section className="fancy-heading center">
                <h1>Lunch Menu</h1>
                <h3>Served Daily, from 11am - 5pm</h3>
              </section>
            </div>
          </div>
        </div>

        <div className="fullSec ipNav">
          <button onClick={() => scrollSmoothTo("mainMenu")} title="Lunch Menu">Lunch Menu</button>
          <button onClick={() => scrollSmoothTo("kids")} title="Kids Menu">Kids Menu</button>
          <button onClick={() => scrollSmoothTo("dessert")} title="Dessert Menu">Dessert Menu</button>
          <button onClick={() => scrollSmoothTo("familyMeals")} title="Family Meals To Go">Family Meals To Go</button>
        </div>

        <div className="page-content food-menus">
          <div className="fullSec newLay">
            <div className="kpWrapXl">
              <div className="right cbp-item">
                <div id="mainMenu" className="cbp-caption second">
                  <div className="cbp-caption-defaultWrap"><h4>Lunch Menu</h4></div>

                  <div className="cbp-caption-activeWrap">
                    <div className="cbp-l-caption-body menuLink">
                      <p className="instr">Click the menu image below to see a larger version.</p>
                      <a href={menuLink} target="_blank" rel="noopener noreferrer" className="menu-item menuImg">
                        <img src={menuImage} alt="Villaggio Lunch Menu, Orange Beach, AL restaurant" className="border" />
                      </a>
                    </div>
                  </div>
                </div>

                <MenuShare />
              </div>

              <div className="left stickyNn fwImage">
                <img src={dishImage} alt="Italian fusion lunch dishes in Orange Beach, AL" />
              </div>

              <div className="clearfix"></div>
              <Disclaimer />

              <div className="mobImage"><img src={dishImageMob} alt="Italian fusion menu in Orange Beach, AL" /></div>
            </div>
          </div>
        </div>
      </div>
      <div className="col-xs-12"><div className="hr hr-png-1"></div></div>
    </div>
  )
}
